import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'mainPage',
    component: () => import('@/views/mainPage.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/home.vue'),
        meta: {
          title: '首页',
        },
      },
      {
        path: '/solution',
        name: 'solution',
        component: () => import('@/views/solution/solution.vue'),
        meta: {
          title: '解决方案',
        },
      },
      {
        path: '/services',
        name: 'services',
        component: () => import('@/views/services/services.vue'),
        meta: {
          title: '产品服务',
        },
      },
      {
        path: '/shop',
        name: 'shop',
        component: () => import('@/views/shop/shop.vue'),
        meta: {
          title: '海蓝商城',
        },
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/about.vue'),
        meta: {
          title: '关于我们',
        },
      },
      {
        path: '/interaction',
        name: 'interaction',
        component: () => import('@/views/interaction/interaction.vue'),
        meta: {
          title: '互动专区',
        },
      },
    ],
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/about/detail.vue'),
    meta: {
      title: '公司概述',
    },
  },
  {
    path: '/news-detail1',
    name: 'newsDetail1',
    component: () => import('@/views/news/detail1.vue'),
    meta: {
      title: '新闻详情1',
    },
  },
  {
    path: '/news-detail2',
    name: 'newsDetail2',
    component: () => import('@/views/news/detail2.vue'),
    meta: {
      title: '新闻详情2',
    },
  },
  {
    path: '/news-detail3',
    name: 'newsDetail3',
    component: () => import('@/views/news/detail3.vue'),
    meta: {
      title: '新闻详情3',
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
